/* External */
import { useRouteMatch } from 'react-router';

/* Theme Assets */
import brandLogo from '~/assets/theme/svg/brand-logo.svg';

/* Other */
import { getJsonImage } from 'src/theme/images';

/* Ott-common */

/* Utils */
import {
  MessagesBannerUpSellGranHermano,
  UPSELL_SHOW_BANNER_PAGES,
  BUSINESS_CAMPAIGN,
  OTT_SSLA_DOMAINS,
  Country,
} from '../utils/constants';
import {
  IS_UPSELL_BANNER_GRAN_HERMANO_ACTIVE,
  OTT_SSLA_BASE_URL,
} from '../utils/env';

/* Hooks */
import { useUserAccount } from '../providers/UserProvider';
// TODO: merge this hook with the other useGetUpsellMessage hook into a single hook
export default function useGetUpSellBannerMessage(isCurableBannerActive) {
  const { url } = useRouteMatch();

  const icon = getJsonImage('brand-logo') || brandLogo;
  const {
    iso2Code,
    msoProvider,
  } = useUserAccount() || {};

  if (isCurableBannerActive) {
    return undefined;
  }

  const isGranHermanoUser = BUSINESS_CAMPAIGN.has(msoProvider);
  const isArgentinaUser = iso2Code.toLowerCase() === Country.ARGENTINA;

  const showUpSellBanner = IS_UPSELL_BANNER_GRAN_HERMANO_ACTIVE && isGranHermanoUser;
  const showUpSellBannerCarousel = IS_UPSELL_BANNER_GRAN_HERMANO_ACTIVE
    && isGranHermanoUser && UPSELL_SHOW_BANNER_PAGES.has(url);

  if (!isGranHermanoUser) {
    return {
      showUpSellBanner: false,
      showUpSellBannerCarousel: false,
    };
  }

  let upSellMessage;

  if (isGranHermanoUser && isArgentinaUser) {
    upSellMessage = {
      ...MessagesBannerUpSellGranHermano.userArgentina,
      link: `${OTT_SSLA_BASE_URL + OTT_SSLA_DOMAINS.gh}`,
      showUpSellBanner,
      showUpSellBannerCarousel,
      icon,
    };
  } else if (isGranHermanoUser) {
    upSellMessage = {
      ...MessagesBannerUpSellGranHermano.userLatam,
      link: `${OTT_SSLA_BASE_URL + OTT_SSLA_DOMAINS.ya}`,
      showUpSellBanner,
      showUpSellBannerCarousel,
      icon,
    };
  }

  return upSellMessage;
}
